import { render, staticRenderFns } from "./PluginModal.vue?vue&type=template&id=6845954c&scoped=true"
import script from "./PluginModal.vue?vue&type=script&lang=js"
export * from "./PluginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6845954c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6845954c')) {
      api.createRecord('6845954c', component.options)
    } else {
      api.reload('6845954c', component.options)
    }
    module.hot.accept("./PluginModal.vue?vue&type=template&id=6845954c&scoped=true", function () {
      api.rerender('6845954c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/PluginModal.vue"
export default component.exports